import type {
  GameMode,
  PollPayload,
  ArenaPayload,
  CoopPayload,
  SandboxPayload,
  SequencerPayload,
  PinpointPayload,
  WallPayload,
} from '@interactive-room';



export function emptyPollPayload(): PollPayload {

  return {

    title: 'Nueva respuesta rápida',

    slides: [

      {

        id: 'slide_1',

        kind: 'multiple-choice',

        prompt: '¿Cuál es tu respuesta?',

        options: ['Opción A', 'Opción B', 'Opción C', 'Opción D'],

      },

    ],

    settings: { anonymous: true, showLiveResults: true },

  };

}



export function emptyArenaPayload(): ArenaPayload {

  return {

    title: 'Nuevo cuestionario',

    questions: [

      {

        id: 'q_1',

        kind: 'multiple-choice',

        prompt: 'Pregunta de ejemplo',

        options: ['Respuesta A', 'Respuesta B', 'Respuesta C', 'Respuesta D'],

        correctIndex: 0,

        points: 100,

        timeLimitSec: 30,

      },

    ],

    settings: { shuffleOptions: false, showCorrectAfter: true, defaultTimeLimitSec: 30 },

  };

}



export function emptyCoopPayload(): CoopPayload {
  return {
    title: 'Crucigrama de la clase',
    board: {
      kind: 'crossword',
      rows: 6,
      cols: 6,
      clues: [
        {
          id: 'a1',
          direction: 'across',
          row: 0,
          col: 0,
          length: 4,
          clue: 'Hogar de aprendizaje',
          answer: 'CASA',
        },
        {
          id: 'd1',
          direction: 'down',
          row: 0,
          col: 0,
          length: 4,
          clue: 'Instituto escolar (abbr.)',
          answer: 'COLE',
        },
      ],
    },
    settings: { turnUnit: 'participant', turnDurationSec: 45 },
  };
}



export function emptySandboxPayload(): SandboxPayload {
  return {
    variant: 'balanza',
    title: 'Equilibra la balanza',
    targetValue: 12,
    initialValue: 0,
    maxValue: 20,
    unitLabel: 'kg',
    deckMode: false,
    availableVariables: [
      { id: 'add1', label: '+ 1 kg', internalValue: 1, type: 'ADD' },
      { id: 'sub1', label: '− 1 kg', internalValue: -1, type: 'ADD' },
      { id: 'add3', label: '+ 3 kg', internalValue: 3, type: 'ADD' },
    ],
  };
}



export function emptySequencerPayload(): SequencerPayload {
  return {
    title: 'Nueva secuencia',
    prompt: 'Ordena los elementos en la secuencia correcta',
    items: ['Primer paso', 'Segundo paso', 'Tercer paso'],
    correctOrder: [0, 1, 2],
  };
}

export function emptyPinpointPayload(): PinpointPayload {
  return {
    title: 'Ubica el punto',
    prompt: 'Toca el lugar correcto en la imagen',
    imageUrl:
      'data:image/svg+xml,' +
      encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"><rect fill="#e2e8f0" width="400" height="300"/><text x="200" y="150" text-anchor="middle" fill="#64748b" font-family="system-ui">Imagen de fondo</text></svg>',
      ),
    target: { x: 0.5, y: 0.5, radius: 0.1 },
  };
}

export function emptyWallPayload(): WallPayload {
  return {
    title: 'Nuevo debate',
    prompt: '¿Cuál es tu postura?',
    maxChars: 140,
    stances: [
      { id: 'for', label: 'A favor', color: '#22c55e' },
      { id: 'against', label: 'En contra', color: '#ef4444' },
    ],
  };
}

export function emptyPayloadForMode(mode: GameMode): unknown {

  switch (mode) {

    case 'poll':

      return emptyPollPayload();

    case 'arena':

      return emptyArenaPayload();

    case 'coop':

      return emptyCoopPayload();

    case 'sandbox':

      return emptySandboxPayload();

    case 'order':

      return emptySequencerPayload();

    case 'point':

      return emptyPinpointPayload();

    case 'wall':

      return emptyWallPayload();

    case 'vincula':
      return {
        title: 'Nuevo emparejamiento',
        pairs: [
          { id: 'p1', ladoA: '', ladoB: '' },
          { id: 'p2', ladoA: '', ladoB: '' },
        ],
      };

  }

}

